/* =====================================================================
   AstaLab 2.0 — policy password centralizzata (revisione r1, obiettivo 5)

   Unico punto che definisce i requisiti della password, usato da
   RegisterPage, ResetPasswordPage, ArtifactDemoBackendAdapter e da ogni
   test — cosi' Artifact/demo e deploy reale non possono mai divergere
   silenziosamente. Il progetto Supabase Dev di riferimento richiede
   "minimum password length = 10": questo modulo è il solo posto da
   aggiornare se quel requisito cambia (es. il progetto richiedesse in
   futuro anche maiuscola/minuscola/numero/simbolo — aggiungere qui
   un'altra costante/funzione, mai divergere fra le due modalità).
   ===================================================================== */

export const AUTH_PASSWORD_MIN_LENGTH = 10;

export function passwordPolicyHint(){
  return "Almeno " + AUTH_PASSWORD_MIN_LENGTH + " caratteri.";
}

/** @returns {{ok:boolean, error:string|null}} */
export function validatePasswordPolicy(password){
  if(!password || password.length < AUTH_PASSWORD_MIN_LENGTH){
    return { ok:false, error:"La password deve avere almeno " + AUTH_PASSWORD_MIN_LENGTH + " caratteri." };
  }
  return { ok:true, error:null };
}
